function GeneralError(data, type) {
    this.name = type ? type : "GeneralError";
    this.message = data.message;
    Error.call(this, data);
}
GeneralError.prototype = new Error();

function CustomError(data, name) {
    this.filesize = "CustomError"
    this.name = name ? name : "CustomError";
    this.message = data;
    Error.call(this, data);
}
CustomError.prototype = new Error();

export const logError = ({ type, error, desc, userMessage, component, line, props }) => {
    try {
        let transaction = window.elasticApm.startTransaction(`${type} error`, type);
        window.elasticApm.addLabels({ 'error-desc': desc })
        window.elasticApm.addLabels({ 'error-component': component })
        window.elasticApm.addLabels({ 'error-Line': line })
        if (props) {
            Object.keys(props).forEach(k => {
                const pr = {};
                pr[`props-${k}`] = props[k];
                window.elasticApm.addLabels(pr);
            });
        }
        let errorObj;
        if (type === "GeneralError") {
            errorObj = new GeneralError(error)
        }
        else if (typeof error === 'string') {
            errorObj = new CustomError(error, type)
        }
        else {
            errorObj = new GeneralError(error, type)
        }
        window.elasticApm.captureError(errorObj)
        transaction.end()
    } catch (error) {
        console.log('error to log apm: ', error);
    }
}
